<div class="flex flex-row flex-wrap">
  <div class="w-full">
    @if (!isDisabled()) {
      <sia-search-box
        [searchExp]="searchExp()"
        (searchExpChange)="searchExp.set($event ?? '')"
        class="w-1/5 min-w-[200px]"
        [searchDisabled]="isDisabled()"
      ></sia-search-box>
    }
  </div>
  @for (val of dataSource(); track val) {
    <sia-check-box
      class="w-full md:w-1/3"
      [style.display]="pageMode() == 'read' ? (val.selected ? '' : 'none') : ''"
      [(value)]="val.selected"
      [label]="val.description"
      [disabled]="isDisabled()"
      style="font-size: 18px"
      (valueChanged)="onItemSelectionChanged()"
      [id]="id() ?? ''"
      [tabindex]="tabDisabled() ? '-1' : '0'"
    >
    </sia-check-box>
  }
  @if (selectedItems().length == 0 && disabled()) {
    <span class="m-auto">{{
      'Nessun elemento selezionato' | siaTranslate
    }}</span>
  }
</div>
